import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';
import 'firebase/functions';
import 'firebase/storage';

var firebaseConfig =
{
    apiKey: "AIzaSyAm6wuoyVcP18_mxBwpek0a_AhhcVh8WEs",
    authDomain: "hofseth-ae6f4.firebaseapp.com",
    databaseURL: "https://hofseth-ae6f4.firebaseio.com",
    projectId: "hofseth-ae6f4",
    storageBucket: "hofseth-ae6f4.appspot.com",
    messagingSenderId: "310150473763",
    appId: "1:310150473763:web:01122d524f31e03aefe996",
    measurementId: "G-0WW0VB1HBG"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

const fb = new Object();
fb.db = firebase.firestore();
fb.auth = firebase.auth();
fb.storage = firebase.storage();
fb.functions = firebase.app().functions('europe-west1');

console.log("* Firebase initialized");
export default fb;